import { FC } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { IconType } from 'shared/icons/SvgIcon';
import { cn } from 'shared/utils/cn';

interface MenuItemProps {
  href: string;
  label: string;
  icon: IconType;
  activePattern?: RegExp;
  className?: string;
}
export const MenuItem: FC<MenuItemProps> = ({
  href,
  label,
  icon: Icon,
  className,
  activePattern = href,
}) => {
  const { pathname } = useLocation();
  const matched = !!pathname.match(activePattern);
  return (
    <li>
      <Link
        to={href}
        aria-current={matched ? 'page' : undefined}
        className={cn(
          'flex items-center justify-center gap-2 rounded-md px-3 py-2 text-sm font-medium transition-colors',
          matched ? 'bg-primary/5 text-primary' : 'text-black/60 hover:bg-black/5 hover:text-black',
          className,
        )}
      >
        <Icon className="h-4 w-4" />
        <span>{label}</span>
      </Link>
    </li>
  );
};
